import moment from "moment";
import axios from "@/axios";

export default {
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		}
	},
	methods: {
		// ------------------- Utils
		dbGetOptions(list) {
			let options = "";

			for(let item of list) {
				if(item !== undefined && item !== null && item !== '') {
					options += `&${item}`;
				}
			}

			if(options.length !== 0) options = '?' + options.substr(1, options.length - 1);

			return options;
		},

		// AI utils
		async dbFullDataOrderAi(id) {
			const url = `/${this.userRole}/order/get-full-data-order-ai?id=${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// AI utils

		// ------------------- End Utils
		async dbGetMangers() {
			const url = `/${this.userRole}/manager`;
			return (await this.$http.get(url)).data.data;
		},
		// Получение токена менеджера для перелогинивания
		async dbGetTokenManagerAsLogin(id) {
			const url = `/${this.userRole}/profile/get-token?id=${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// Получение списка менеджеров для перелогинивания
		async dbGetListMangersLogin() {
			const url = `/${this.userRole}/profile/get-list-manager-login`;
			return (await this.$http.get(url)).data.data;
		},
		// Получение списка менеджеров
		async dbGetListMangers() {
			const url = `/${this.userRole}/manager/get-list-manager`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetListMangersSecond() {
			const url = `/${this.userRole}/manager/get-list-manager-second`;
			return (await this.$http.get(url)).data.data;
		},
		// Получение списка авторов для логов
		async dbGetListAuthors() {
			const url = `/${this.userRole}/author/get-list-author`;
			return (await this.$http.get(url)).data.data;
		},
		async dbUpdateListWhatsappWeek(arr) {
			const url = `/${this.userRole}/manager/set-list-whatsapp-week`;
			const data = { arr };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		/* Получение графика дежурств по Wharsapp на всю неделю*/
		async dbGetDutyWhatsappListWeek() {
			const url = `/${this.userRole}/manager/get-duty-whatsapp-list-week`;
			return (await this.$http.get(url)).data.data;
		},
		/* Получение графика дежурств на всю неделю*/
		async dbGetDutyScheduleListWeek() {
			const url = `/${this.userRole}/manager/get-duty-schedule-list-week`;
			return (await this.$http.get(url)).data.data;
		},
		/* Получение графика дежурств ответсвенных на всю неделю*/
		async dbGetDutyScheduleListResponsibleWeek() {
			const url = `/${this.userRole}/manager/get-duty-schedule-list-responsible-week`;
			return (await this.$http.get(url)).data.data;
		},
		/* Получение списка незанятых менеджеров в этот день*/
		async dbGetDutyScheduleList(day, line) {
			const url = `/${this.userRole}/manager/get-duty-schedule-list?day=${day}&line=${line}`;
			return (await this.$http.get(url)).data.data;
		},
		/* Получение списка ответсвенного менеджеров в этот день*/
		async dbGetResponsibleDutyScheduleList(day, line) {
			const url = `/${this.userRole}/manager/get-responsible-duty-schedule-list?day=${day}&line=${line}`;
			return (await this.$http.get(url)).data.data;
		},
		/* Отправка списка менеджеров на дежурство */
		async dbAddDutyManagers(arr, theDay, line) {
			const url = `/${this.userRole}/manager/add-duty-managers`;
			const data = { arr, day: theDay, line: line };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},		
		/* Отправка списка менеджеров на дежурство */
		async dbAddDutyResponsibleManagers(theDay, line, responsible, managers) {
			const url = `/${this.userRole}/manager/add-duty-responsible-managers`;
			const data = { day: theDay, line: line, responsible: responsible, managers: managers};
			const res = await this.$http.post(url, data);
			return res.data.data;
		},		
		// Удаление менеджера из гарфика на выбранный день
		async dbDeleteManagerFromDutyDay(day, managerId, line) {
			const url = `/${this.userRole}/manager/delete-manager-from-duty-day`;
			const data = { day: day, managerId: managerId, line: line };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},	
		// Назначение нового главного менеджера
		async dbChangeFinishGeneralManager(managerId) {
			const url = `/${this.userRole}/manager/change-finish-general-manager`;
			const data = { managerId: managerId };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},	
		// Перевод менеджера в оффлайн
		async dbSwitchOfflineManager() {
			const url = `/${this.userRole}/profile/switch-offline-manager`;
			return (await this.$http.get(url)).data.statusManager;
		},	
		// Перевод менеджера в онлайн
		async dbSwitchOnlineManager() {
			const url = `/${this.userRole}/profile/switch-online-manager`;
			return (await this.$http.get(url)).data.statusManager;
		},	
		// Получение статуса менеджера
		async dbGetStatusManager() {
			const url = `/${this.userRole}/profile/get-status-manager`;
			return (await this.$http.get(url)).data.statusManager;
		},	
		// Расчет зп менеджеров
		async dbGetCalculateSalaryManagers({off, to}) {
			let options = '';

			if(off !== '' && off !== null && off !== undefined)
				options += `&filter[date_from]=${moment(off).format('YYYY-MM-DD')}`;

			if(to !== '' && to !== null && to !== undefined)
				options += `&filter[date_to]=${moment(to).format('YYYY-MM-DD')}`;

			
			const url = `/${this.userRole}/manager/get-calculate-salary?${options}`;
			return (await this.$http.get(url)).data.data;

		},
		// Расчет зп авторов
		async dbGetCalculateSalaryAuthors({off, to}) {
			let options = '';

			if(off !== '' && off !== null && off !== undefined)
				options += `&filter[date_from]=${moment(off).format('YYYY-MM-DD')}`;

			if(to !== '' && to !== null && to !== undefined)
				options += `&filter[date_to]=${moment(to).format('YYYY-MM-DD')}`;

			const url = `/${this.userRole}/author/get-calculate-salary?${options}`;
			return (await this.$http.get(url)).data.data;

		},
		async dbGetAuthors() {
			const url = `/${this.userRole}/author`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetAuthorCostPerPage(authorId, websiteId) {
			const url = `/${this.userRole}/author/get-author-cost-per-page/${authorId}?item=${websiteId}`;
			return (await this.$http.get(url)).data;
		},
		async dbGetAuthorCostListPoint(authorId) {
			const url = `/${this.userRole}/author/get-author-cost-list-point/${authorId}`;
			return (await this.$http.get(url)).data.data;
		},
		async dbSetAuthorCostPerPage(authorId, items, websiteId) {
			const url = `/${this.userRole}/author/set-author-cost-per-page/${authorId}`;
			const data = { items: items, item: websiteId };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},	
		async dbGetClients() {
			const url = `/${this.userRole}/client`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetClient(id) {
			const url = `/${this.userRole}/client/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// ------------------- Users

		// ------------------- End Users

		// ------------------- Task
		async dbCreateTask(date, description, idOrder) {
			let formData = {
				date_time: moment(date).format("YYYY-MM-DD HH:MM:ss"),
				description: description,
				order_id: idOrder,
			};

			const url = `/${this.userRole}/task/create/`;
			return (await this.$http.post(url, formData)).data.data;
		},

		async dbCreateTaskToClient(date, description, idClient) {
			let formData = {
				date_time: moment(date).format("YYYY-MM-DD HH:MM:ss"),
				description: description,
				user_client_id: idClient,
			};

			const url = `/${this.userRole}/task/create/`;
			return (await this.$http.post(url, formData)).data.data;
		},

		async dbViewTask(taskId) {
			const url = `/${this.userRole}/task/view/${taskId}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbCompleteTask(taskId, isCompleted = true) {
			const url = `/${this.userRole}/task/complete/${taskId}`;
			const data = { is_completed: isCompleted };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbCloseTask(taskId) {
			const url = `/${this.userRole}/task/delete/${taskId}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbNotRelevantTask(taskId) {
			const url = `/${this.userRole}/task/not-relevant/${taskId}`;
			return (await this.$http.post(url)).data.data;
		},
		// ------------------- End Task


		// ------------------- Tickets
		async dbGetTickets(type, options = '') {
			const url = `/${this.userRole}/order?tab=${type}${options}`;
			return (await this.$http.get(url)).data;
		},

		// Отключение фоллапов для клиента
		async dbSwitchhNotAllowedFollowUpOrder(id) {
			const url = `/${this.userRole}/order/switch-not-allowed-follow-up-order/${id}`;
			return (await this.$http.get(url)).data.statusFollowUpOrder;
		},	
		// Включение фоллапов для клиента
		async dbSwitchAllowedFollowUpOrder(id) {
			const url = `/${this.userRole}/order/switch-allowed-follow-up-order/${id}`;
			return (await this.$http.get(url)).data.statusFollowUpOrder;
		},	

		async dbGetFilteredTickets({type, limit, offset, off, to, manager, author, client, work, level, name, premium}) {
			let options = '';

			if(off !== '' && off !== null && off !== undefined)
				options += `&filter[date_from]=${moment(off).format('YYYY-MM-DD')}`;

			if(to !== '' && to !== null && to !== undefined)
				options += `&filter[date_to]=${moment(to).format('YYYY-MM-DD')}`;

			if(manager !== '' && manager !== null && manager !== undefined)
				options += `&filter[manager]=${manager}`;

			if(author !== '' && author !== null && author !== undefined)
				options += `&filter[author]=${author}`;

			if(client !== '' && client !== null && client !== undefined)
				options += `&filter[client]=${client}`;

			if(name !== '' && name !== null && name !== undefined)
				options += `&filter[name]=${name}`;

			if(premium !== '' && premium !== null && premium !== undefined)
				options += `&filter[premium]=${premium}`;

			if(work !== '' && work !== null && work !== undefined)
				options += `&filter[work_type]=${work}`;

			if(level !== '' && level !== null && level !== undefined)
				options += `&filter[quality_level]=${level}`;

			if(limit !== '' && limit !== null && limit !== undefined) {
				options += `&limit=${limit}`;
			}
			if(offset !== '' && offset !== null && offset !== undefined) {
				options += `&offset=${offset}`;
			}

			return await this.dbGetTickets(type, options);
		},

		async dbGetClientTickets(id, {
			tab,
			offset,
			limit,
			date_from,
			date_to,
			name,
		}) {
			let options = "";

			if(tab !== undefined) 		options += `&tab=${tab}`;
			if(offset !== undefined) 	options += `&offset=${offset}`;
			if(limit !== undefined) 	options += `&limit=${limit}`;
			if(date_from !== undefined) options += `&filter[date_from]=${moment(date_from).format("YYYY-MM-DD")}`;
			if(date_to !== undefined) 	options += `&filter[date_to]=${moment(date_to).format("YYYY-MM-DD")}`;
			if(name !== undefined) 		options += `&filter[name]=${name}`;

			const url = `/${this.userRole}/client/get-orders?id=${id}${options}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbSendOrderApproval(id) {
			const url = `/${this.userRole}/order/send-for-approval/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbConfirmOrder(id) {
			const url = `/${this.userRole}/order/confirm/${id}`;
			return (await this.$http.post(url)).data.data;
		},
		// ------------------- End Tickets

		// ------------------- Logs
		async dbGetLogs(options = '') {
			const url = `/${this.userRole}/log?${options}`;
			return (await this.$http.get(url)).data;
		},

		async dbGetFilteredLogs({off, to, manager, author, search, limit, offset}) {
			let options = '';

			if(off !== '' && off !== null && off !== undefined)
				options += `&filter[date_from]=${moment(off).format('YYYY-MM-DD')}`;

			if(to !== '' && to !== null && to !== undefined)
				options += `&filter[date_to]=${moment(to).format('YYYY-MM-DD')}`;

			if(manager !== '' && manager !== null && manager !== undefined)
				options += `&filter[manager]=${manager}`;

			if(author !== '' && author !== null && author !== undefined)
				options += `&filter[author]=${author}`;

			if(search !== '' && search !== null && search !== undefined)
				options += `&filter[search]=${search}`;

			if(limit !== '' && limit !== null && limit !== undefined) {
				options += `&limit=${limit}`;
			}
			if(offset !== '' && offset !== null && offset !== undefined) {
				options += `&offset=${offset}`;
			}

			return await this.dbGetLogs(options); 
		},
		// ------------------- End Logs


		// ------------------- Order
		async dbGetSearchGlobalOrderById(id) {
			const url = `/${this.userRole}/order/get-search-global-order-by-id/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		
		// Смена статуса заказа для админа
		async dbChangeOrderStatus(id, new_status) {
			let url = `${this.userRole}/order/change-order-status/${id}`;
			const data = { new_status: new_status };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbMoveTrashOrder(id, reason) {
			let url = `${this.userRole}/order/move-trash/${id}`;
			const data = { fail_reason_id: reason };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbChangeManagerInOrder(id, new_manager) {
			let url = `${this.userRole}/order/change-manager-in-order/${id}`;
			const data = { new_manager: new_manager };
			return (await this.$http.post(url, data)).data.data;
		},
		async dbChangeManagerSecondInOrder(id, new_manager) {
			let url = `${this.userRole}/order/change-manager-second-in-order/${id}`;
			const data = { new_manager: new_manager };
			return (await this.$http.post(url, data)).data.data;
		},

		/* Получение задач для заказа */
		async dbViewOrderTasks(id) {
			const url = `/${this.userRole}/order/get-order-tasks/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Получение логов для заказа */
		async dbViewOrderLogs(id) {
			const url = `/${this.userRole}/order/get-order-logs/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Получение комментариев для заказа */
		async dbViewOrderComments(id) {
			const url = `/${this.userRole}/order/get-order-comments/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Получение количества задач для заказа */
		async dbGetCountTaskToOrder(id) {
			const url = `/${this.userRole}/order/get-count-task-to-order/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Получение количества комментариев для заказа */
		async dbGetCountCommentToOrder(id) {
			const url = `/${this.userRole}/order/get-count-comment-to-order/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Добавление нового комментария к заказу */
		async dbPushNewCommentToOrder(id, newComment) {
			const url = `/${this.userRole}/order/push-order-comments/${id}`;
			const data = { 
							newComment: newComment,
						 };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},

		async dbManagerGetOrder(id, new_manager) {
			let url = `${this.userRole}/order/manager-get-order/${id}`;
			const data = { new_manager: new_manager };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbNewPriceJMPopupActive(id, newPriceInput) {
			let url = `${this.userRole}/order-milestone/set-new-price-jm/${id}`;
			const data = { new_price: newPriceInput };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbNewPriceSPopupActive(id, newPriceInput) {
			let url = `${this.userRole}/order-milestone/set-new-price-s/${id}`;
			const data = { new_price: newPriceInput };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbViewOrder(id) {
			const url = `${this.userRole}/order/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbUpdateOrder(idModel, data) {
			const url = `/${this.userRole}/order/update/${idModel}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetClientNotAnswer(id) {
			const url = `/${this.userRole}/order/set-client-not-answer/${id}`
			return (await this.$http.post(url));
		},

		async dbSetCloseOrderWithoutNotice(id) {
			const url = `/${this.userRole}/order/set-close-order-without-notice/${id}`
			return (await this.$http.post(url));
		},

		async dbSetAutoSendFiles(id, isAllow) {
			const url = `/${this.userRole}/order/set-autosend-files/${id}`
			const data = { is_allow: isAllow };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbGetRecommendedPrice(id) {
			const url = `/${this.userRole}/order/get-recommended-price/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbGetRecommendedPriceForCreating({subject, workType, level, pagesAmount, dueDate}) {
			const url = `/${this.userRole}/order/get-recommended-price-new-order`;
			const options =
				`?subject_id=${subject}` +
				`&work_type_id=${workType}` +
				`&quality_level_id=${level}` +
				`&pages_number=${pagesAmount}` +
				`&due_date=${dueDate}`;

			return (await this.$http.get(url + options)).data.data;
		},

		async dbBackOrderToProcess(id) {
			const url = `/${this.userRole}/order/edit/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbDeleteAuthorFromOrder(id) {
			const url = `/${this.userRole}/order/delete-author/${id}`;
			return (await this.$http.post(url)).data.data;
		},
		// ------------------- End Order


		// ------------------- Chat
		async dbChatClientMarkAsRead(id) {
			const url = `/chat/mark-as-read/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbChatAuthorMarkAsRead(id) {
			const url = `/chat-author/mark-as-read/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Получение 50 последних сообщений */
		async dbLast50MessagesManager() {
			const url = `/chat/view-last50-message`;
			return (await this.$http.get(url)).data.data;
		},		
		// ------------------- End Chat

		// ------------------- Stage
		async dbViewStages(id) {
			const url = `/${this.userRole}/order/get-milestones/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbSetPriceAuthorAmount(id, newPriceInput) {
			let url = `${this.userRole}/order-milestone/set-price-author-amount/${id}`;
			const data = { new_amount: newPriceInput };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetNewAuthorAmount(id, newPriceInput) {
			let url = `${this.userRole}/order-milestone/set-new-author-amount/${id}`;
			const data = { new_amount: newPriceInput };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbCreateStage(id, data) {
			const url = `/${this.userRole}/order/create-milestone/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateStage(id, data) {
			const url = `/${this.userRole}/order/update-milestone/${id}`
			return (await this.$http.post(url, data)).data.data;
		},

		async dbRemoveStage(id) {
			const url = `/${this.userRole}/order/delete-milestone/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbConfirmStagePayout(id) {
			const url = `/${this.userRole}/order/confirm-milestone/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbConfirmStagePayoutInBank(id) {
			const url = `/${this.userRole}/order/confirm-payment-milestone/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbSetStageDone(id) {
			const url = `${this.userRole}/order/complete-with-payment-to-author/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbStageDoneAfterPatchMode(id) {
			const url = `${this.userRole}/order/complete-patch-mode-with-payment-to-author/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		/* Отправка этапа на доработку с комментом автору */
		async dbSetStagePatchMode(id, newComment) {
			const url = `/${this.userRole}/order/set-patch-mode-stage/${id}`;
			const data = { 
							newComment: newComment,
						 };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},

		async dbSetStageFailed(id, reason) {
			let url = `${this.userRole}/order-milestone/set-failed/${id}`;
			const data = { fail_reason_id: reason };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSendStageFiles(id) {
			const url = `${this.userRole}/order/send-files/${id}`;
			return (await this.$http.post(url)).data.data;
		},
		// ------------------- End Stage

		// ------------------- Author Main
		async dbGetAuthorTasks() {
			const url = `/${this.userRole}/task/get-author-tasks`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetMyAuthorsTasks() {
			const url = `/${this.userRole}/task/get-my-authors-tasks`;
			return (await this.$http.get(url)).data.data;
		},
		async dbViewPatchModeStages(id) {
			const url = `/${this.userRole}/order/get-patch-mode-stages/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// ------------------- End Author Main

		// ------------------- Author finding
		async dbInviteAuthor(orderId, authorId) {
			const url = `/${this.userRole}/order/invite-author/${orderId}`;
			const data = { author_id: authorId };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetAuthor(orderId, authorId) {
			const url = `/${this.userRole}/order/set-author/${orderId}`;
			const data = { author_id: authorId };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbAddAuthorToFavorite(authorId) {
			const url = `/${this.userRole}/author/add-author-to-favorite/${authorId}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbDeleteAuthorFromFavorite(authorId) {
			const url = `/${this.userRole}/author/delete-author-from-favorite/${authorId}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbGetAuthorInviteList({name, level, subject}) {
			let options = "";

			if(name !== undefined) options += `&filter[name]=${name}`;
			if(level !== undefined) options += `&filter[quality_level]=${level}`;
			if(subject !== undefined) options += `&filter[subject]=${subject}`;

			if(options.length > 0) options = '?' + options.substr(1, options.length);

			const url = `/${this.userRole}/author/get-author-list-for-invite${options}`;
			return (await this.$http.get(url)).data.data;
		},
		// ------------------- End Author finding

		// ------------------- Files
		async dbUploadMany(files, idChat) {
			if (files.length === 0) return [];
			const url = '/upload/many';
			const params = idChat ? `?chat_id=${idChat}` : "";
			const res = await this.$http.post(url + params, this.$formData({ files }));
			return res.data.data.map(item => ({
				url: item.path,
				fullUrl: item.url,
			}));
		},
		async dbDeleteOne(orderId, path) {
			const url = "/upload/delete";
			const data = { order_id: orderId, patch: path };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		async dbDeleteOnePatchMode(orderId, path) {
			const url = "/upload/delete-patch-mode";
			const data = { order_id: orderId, patch: path };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		// ------------------- End Files

		// ------------------- Settings
		async dbGetFailReasons() {
			const res = await this.$http.get("/settings/get-order-fail-reasons");
			return res.data.data;
		},
		// ------------------- End Settings

		// ------------------- Whatsapp
		async dbGetWhatsappListChannels(options) {
			let url = `/${this.userRole}/whatsapp/whatsapp-list-channels`;

			if(options !== undefined) {
				let optionsUrl = "";

				if(options.name !== undefined && options.name !== "")
					optionsUrl += `&filter[name]=${options.name}`;

				if(options.plainId !== undefined && options.plainId !== "")
					optionsUrl += `&filter[plainId]=${options.plainId}`;

				if(options.manager !== undefined && options.manager !== "")
					optionsUrl += `&filter[manager]=${options.manager}`;

				if(optionsUrl.length > 0) optionsUrl = '?' + optionsUrl.substr(1, optionsUrl.length);

				url += optionsUrl;
			}

			return (await this.$http.get(url)).data.data;
		},
		async dbviewAllChatWhatsapp(options) {
			let url = options ? `/${this.userRole}/whatsapp/view-all-chat` + options : `/${this.userRole}/whatsapp/view-all-chat`;
			return (await this.$http.get(url)).data.data;
		},
		async dbviewInfoChatWhatsapp(id) {
			const url = `/${this.userRole}/whatsapp/view-info-chat/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		async dbviewOneChatWhatsapp(id) {
			const url = `/${this.userRole}/whatsapp/view-one-chat/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// Отсылка текстового сообщения
		async dbSendMessageWhatsapp(id, mess, replyToId) {
			const url = `/${this.userRole}/whatsapp/send-message/${id}`;
			const data = { mess: mess, replyToId: replyToId };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		// Отсылка файла в чат whatsapp
		async dbSendFileWhatsapp(id, file, replyToId) {
			const url = `/${this.userRole}/whatsapp/send-file/${id}`;
			const data = { file: file, replyToId: replyToId };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		// Отмечать чат в ватсапе как прочитанный
		async dbChatWhatsAppMarkAsRead(id) {
			const url = `/${this.userRole}/whatsapp/mark-as-read/${id}`;
			return (await this.$http.post(url)).data.data;
		},
		// Назначение менеджера в чат
		async dbChangeManagerInChatWhatsApp(id, new_manager) {
			let url = `${this.userRole}/whatsapp/change-manager-in-chat-whatsapp/${id}`;
			const data = { new_manager: new_manager };
			return (await this.$http.post(url, data)).data.data;
		},
		// ------------------- End Whatsapp

		// ------------------- Websites
		async dbGetWebSites(options) {
			let url = `/${this.userRole}/website`;

			if(options !== undefined) {
				let optionsUrl = "";

				if(options.name !== undefined && options.name !== "")
					optionsUrl += `&filter[site]=${options.name}`;

				if(options.uid !== undefined && options.uid !== "")
					optionsUrl += `&filter[site_uid]=${options.uid}`;

				if(options.email !== undefined && options.email !== "")
					optionsUrl += `&filter[email]=${options.email}`;

				if(options.managerPercent !== undefined && options.managerPercent !== "")
					optionsUrl += `&filter[commission_manager_percent]=${options.managerPercent}`;

				if(optionsUrl.length > 0) optionsUrl = '?' + optionsUrl.substr(1, optionsUrl.length);

				url += optionsUrl;
			}

			return (await this.$http.get(url)).data.data;
		},

		async dbViewWebsite(id) {
			const url = `/${this.userRole}/website/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Загрузка для конкретного сайта списка чат-шаблонов */
		async dbWebsiteGetChatResponse(id) {
			const url = `/${this.userRole}/website/get-chat-response/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Обновление для конкретного сайта конкретного шаблона для чата */
		async dbWebsiteSetChatResponseTemplate(id, emailTemplateAnswer) {
			const url = `/${this.userRole}/website/set-chat-response-template/${id}`;
			const data = { 
							templateId: emailTemplateAnswer.templateId,
							templateTemplate: emailTemplateAnswer.templateTemplate,
							templatePresentationPdf: emailTemplateAnswer.templatePresentationPdf,
							presentationPdfNameHref: emailTemplateAnswer.presentationPdfNameHref,
						 };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},

		/* Загрузка для конкретного сайта списка шаблонов автоматичеких ответов */
		async dbWebsiteGetAutoEmailAnswer(id) {
			const url = `/${this.userRole}/website/get-auto-email-answer/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		/* Обновление для конкретного сайта конкретного шаблона автоматичекого ответа */
		async dbWebsiteSetAutoEmailAnswer(id, emailTemplateAnswer) {
			const url = `/${this.userRole}/website/set-auto-email-answer/${id}`;
			const data = { 
							templateId: emailTemplateAnswer.templateId,
							templateTemplate: emailTemplateAnswer.templateTemplate,
							templateLetterSubject: emailTemplateAnswer.templateLetterSubject,
							templatePresentationPdf: emailTemplateAnswer.templatePresentationPdf,
						 };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},

		async dbCreateWebsite(data) {
			const url = `/${this.userRole}/website/create`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateWebsite(id, data) {
			const url = `/${this.userRole}/website/update/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbDeleteWebsite(id) {
			const url = `/${this.userRole}/website/delete/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbGetManagerProfiles() {
			const url = `/${this.userRole}/profile/websites`;
			return (await this.$http.get(url)).data.data;
		},

		async dbGetManagerProfilesByAdmin(managerId) {
			const url = `/${this.userRole}/manager/websites/${managerId}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbUpdateManagerProfiles(websites) {
			const url = `/${this.userRole}/profile/update-websites`;
			const data = { websites };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateManagerProfilesByAdmin(managerId, websites) {
			const url = `/${this.userRole}/manager/update-websites/${managerId}`;
			const data = { websites };
			return (await this.$http.post(url, data)).data.data;
		},
		// ------------------- End Websites

		// ------------------- Partners
		async dbGetPartners(options) {
			let url = `/${this.userRole}/partners`;

			if(options !== undefined) {
				let optionsUrl = "";

				if(options.email !== undefined && options.email !== "")
					optionsUrl += `&filter[email]=${options.email}`;

				// if(options.managerPercent !== undefined && options.managerPercent !== "")
				// 	optionsUrl += `&filter[commission_manager_percent]=${options.managerPercent}`;

				if(optionsUrl.length > 0) optionsUrl = '?' + optionsUrl.substr(1, optionsUrl.length);

				url += optionsUrl;
			}

			return (await this.$http.get(url)).data.data;
		},

		async dbViewPartner(id) {
			const url = `/${this.userRole}/partners/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbCreatePartner(data) {
			const url = `/${this.userRole}/partners/create`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdatePartner(id, data) {
			const url = `/${this.userRole}/partners/update/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbViewPartnerWebsites() {
			const url = `/${this.userRole}/partners/view-websites`;
			return (await this.$http.get(url)).data.data;
		},

		async dbDeletePartner(id) {
			const url = `/${this.userRole}/partners/delete/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		// ------------------- End Partners

		// ------------------- Stats
		async dbGetGraph(graphicUrl, from, to) {
			const url = `/${this.userRole}${graphicUrl}`;
			let options = "";

			if(from !== undefined && from !== null) options += `&filter[date_from]=${from}`;
			if(to !== undefined && to !== null) options += `&filter[date_to]=${to}`;

			if(options.length !== 0 && url.indexOf("?") === -1)
				options = '?' + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetPaidOrders(from, to) {
			const url = `/stats/get-orders-paid`;
			return await this.dbGetGraph(url, from, to);
		},

		async dbGetSiteIncome(idWebsite, from, to) {
			const url = `${this.userRole}/stats/get-graph-income`;

			const optionsList = [
				`filter[site_id]=${idWebsite}`,
				`filter[date_from]=${from}`,
				`filter[date_to]=${to}`,
			];
			const options = this.dbGetOptions(optionsList);

			return (await this.$http.get(url + options)).data.data;
		}
		// ------------------- End Stats
	}
}
